import { ResetPasswordChangeModel } from '.';

import { formatMessage } from 'src/api';
import MESSAGES from 'src/app/Pages/Home/Reset-Password/ResetPassword.messages';

export const resetPasswordChangeFormData = (): ResetPasswordChangeModel => ({
  repeatPassword: {
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.changePwNewError}),
    label: formatMessage({...MESSAGES.changePwNewLabel}),
    name: 'password',
    type: 'password',
    placeholder: formatMessage({...MESSAGES.changePwNewLabel}),
    required: true,
    validation: 'password.Repeat',
    value: '',
  },
  password: {
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.changePwNewRepeatError}),
    label: formatMessage({...MESSAGES.changePwNewRepeatLabel}),
    name: 'repeatPassword',
    type: 'password',
    placeholder: formatMessage({...MESSAGES.changePwNewRepeatLabel}),
    required: true,
    validation: 'isPassword',
    value: '',
  } 
});
